<template>
    <div>
        <multiselect v-model="value" :placeholder="translation.select_your_country" :show-labels="false" label="country" track-by="country" :options="options" :option-height="104" :searchable="true" :allow-empty="false">
            <template slot="singleLabel" slot-scope="props"><img class="option__image" :src="`/internacional/public/images/flags-small/${imgPath(props.option.slug)}.jpg`"><span class="option__desc"><span class="option__title">{{ props.option.country }}</span></span></template>
            <template slot="option" slot-scope="props"><img class="option__image" :src="`/internacional/public/images/flags-small/${imgPath(props.option.slug)}.jpg`">
                <div class="option__desc"><span class="option__title">{{ props.option.country }}</span></div>
            </template>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: "modal-multiselect",
    components: {
        Multiselect
    },
    props: {
        view: {
            type: Array,
        },
        getCountry: {
            type: Function
        },
        translation: null,
        getDefaultCountry: null
    },
    data () {
        return {
            value: null,
            options: []
        }
    },
    mounted() {
        this.options = this.view;
    },
    methods: {
        getImagePath(filterSelected) {
            this.toolsSelected(filterSelected)
        },
        imgPath(slug) {
            if (slug != undefined) {
                return slug.substr(-2)
            }
        }
    },
    watch: {
        getDefaultCountry(newCountry, oldCountry) {
            this.value = newCountry
        },
        value(newValue) {
            this.getCountry(newValue)
        }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

.multiselect {
    border-bottom: 4px solid hsl(204deg 19% 95%);
    margin: 0 auto;
}
.option__image {
    width: 2.2rem !important;
    height: 1.5rem !important;
    border-radius: 4px;
    margin-right: 1rem;
    box-shadow: 0px 0px 3px #ccc;
    opacity: 0.8;
}
.multiselect__option {
    border-top: 1px solid hsl(204deg 19% 95%) !important;
    display: inline-flex;
    align-items: center;
    width: 100%;
}
.multiselect__tags {
    border-radius: 0;
    border: 0;
}
.multiselect__content-wrapper {
    border-bottom: 1px solid hsl(204deg 19% 95%) !important;
    border-radius: 0;
}
.multiselect__option--highlight {
    background: #0080FC;
}
.multiselect__option--selected.multiselect__option--highlight{
    background: #0080FC;
}

.multiselect__tags, .multiselect__element,
.multiselect__input, .multiselect__single{
    background-color: #f8fafd;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/lib/ModalMultiselect.vue